import React, { useState, useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import styled from "styled-components";
import { toTitleCase } from "../../utils/myFunctions";
import { makePostRequest } from "../../services/httpHelper";
import ErrorHandler from "../../services/ErrorHandler";

export default function MpesaCheckout() {
  const { state } = useLocation();          // order passed via navigate()
  const order = state;
  const navigate = useNavigate();

  /* ───── local state ───── */
  const [years,  setYears]  = useState(1);
  const [phone,  setPhone]  = useState("");
  const [loading, setLoading] = useState(false);
  const [error,   setError]   = useState("");
  const [finalPrice, setFinalPrice] = useState(order.price);
  const [isSubmitting, setIsSubmitting] = useState(false)
  const [serverError,setServerError] = useState(null);

  const isOneTime = ["solo", "team"].includes(order.product.toLowerCase());


  const handlePayment = async () => {

    const payload ={
        order_id: order.orderId,
        plan:order.plan,
        phone,
        years,
      }
      setLoading(true);
      try {
          const res = await makePostRequest('payments/mpesa',payload);
              if (res && res.errorType) {
  
                
                  setIsSubmitting(false);
                  const errorMessage = ErrorHandler(res)
                  console.log(errorMessage)
                  setServerError(`Server or Network error occured`)
        
              } else {
                   navigate("/waiting-mpesa", {
        state: { orderId: res.data.order.id, amount: res.data.order.amount },
      });
            
            }
        
      } catch (err) {
      setError(err.response?.data?.message || "Failed to initiate payment.");
        console.error(err);
      } finally {
        setLoading(false);
      }
    };

  /* price calculator */
  useEffect(() => {
    if (!isOneTime) {
      const factor = Math.pow(0.9, years - 1);  // 10 % discount / extra year
      setFinalPrice(Math.round(order.price * years * factor));
    } else setFinalPrice(order.price);
  }, [years]);

  

  return (
    <Wrapper>
      <FormCard>
        <h2>Complete Payment via MPESA</h2>
        <p>Please review your order before continuing.</p>

        <OrderSummary>
          <Row><strong>Customer:</strong> {toTitleCase(order.customer)}</Row>
          <Row><strong>Edition:</strong> {toTitleCase(order.product)}</Row>
          <Row><strong>Plan:</strong> {toTitleCase(order.plan)}</Row>

          {isOneTime ? (
            <Row><strong>Total:</strong> KES {finalPrice} (One-time)</Row>
          ) : (
            <>
              <Row>
                <strong>Years:</strong>
                <select value={years} onChange={e => setYears(+e.target.value)}>
                  {[1,2,3,4,5].map(y => (
                    <option key={y} value={y}>{y}</option>
                  ))}
                </select>
              </Row>
              <Row><strong>Total:</strong> KES {finalPrice} (Discount applied)</Row>
            </>
          )}
        </OrderSummary>

        <Note>
          🔐 Secure & Fast — Your licence and download link will be sent after payment.
        </Note>

        <input
          type="tel"
          placeholder="MPESA phone number"
          value={phone}
          onChange={e => setPhone(e.target.value)}
          required
        />

        {error && <ErrorMsg>{error}</ErrorMsg>}

        <button onClick={handlePayment} disabled={loading} style={{backgroundColor:"green"}}>
          {loading ? "Processing…" : "Pay Now"}
        </button>
      </FormCard>
    </Wrapper>
  );
}

// Styled Components
const Wrapper = styled.div`
  min-height: 100vh;
  display: flex;
  justify-content: center;
  align-items: center;
  background: #f7f9fc;
  padding: 20px;
`;

const FormCard = styled.div`
  background: white;
  padding: 30px;
  border-radius: 16px;
  box-shadow: 0 8px 20px rgba(0,0,0,0.05);
  max-width: 500px;
  width: 100%;
  text-align: center;

  h2 {
    margin-bottom: 10px;
    color: #222;
  }

  input {
    margin-top: 20px;
    padding: 12px;
    width: 100%;
    border: 1px solid #ccc;
    border-radius: 8px;
  }

  button {
    margin-top: 20px;
    width: 100%;
    padding: 12px;
    background: #3b0a63;
    color: white;
    border: none;
    border-radius: 8px;
    font-weight: bold;
    cursor: pointer;

    &:hover {
      background: #5e2a84;
    }
  }
`;

const OrderSummary = styled.div`
  margin: 20px 0;
  background: #f0f0fa;
  border-radius: 8px;
  padding: 16px;
  text-align: left;
`;

const Row = styled.div`
  margin: 6px 0;
  font-size: 15px;

  select {
    margin-left: 10px;
    padding: 6px;
    border-radius: 6px;
    border: 1px solid #ccc;
  }
`;

const Note = styled.div`
  font-size: 13px;
  color: #555;
  margin-top: 10px;
`;

const ErrorMsg = styled.p`
  color:#d00;margin-top:10px;font-size:14px;`;

